module.exports = __webpack_public_path__ + "img/closebtn-icon-active.7f52d7ba.svg";